function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { defineComponent, reactive, ref, computed, getCurrentInstance } from "vue";
import { useModelStore } from "@/views/creative/model-editor/model-mixin";
import useIdToFindCategory from "@/views/creative/utils/use-id-to-find-category";
import { language } from "@/common/storage";
import isMaterialWarehouse from "@/common/is-warehouse";
import DialogForm from "@/components/DialogForm/index.vue";
import { Message } from "element-ui";
import ResetResource from "@/views/creative/components/reset-resource.vue";
import CategoryMirrorBtn from "@/views/creative/template/category-mirror-btn.vue";
import { getAnimationList, getModelAnimationByAnimationCategory } from "@/views/creative/utils/model-animation-utils";
import AnimationInlineForm from "@/views/creative/model-editor/animation-inline-form.vue";
import FormPanel from "@/views/creative/components/form-panel.vue";
import { PtButtonType, PtButtonTheme, PtButtonSize } from "@com/pt-components/pt-button/enum";
import _ from "lodash";
import { isPresetOptionCategory } from "@/store/creative/common/category";
import useIdToFindResourceList from "@/views/creative/utils/use-id-to-find-resource-list";
export default defineComponent({
    components: {
        FormPanel: FormPanel,
        AnimationInlineForm: AnimationInlineForm,
        CategoryMirrorBtn: CategoryMirrorBtn,
        ResetResource: ResetResource,
        DialogForm: DialogForm
    },
    setup: function setup(props) {
        var setRollBackDataById = function setRollBackDataById(id) {
            var cat = useIdToFindCategory({
                category: templateCategory.value,
                categoryId: id
            });
            if (cat && currentResetModel.value && !currentResetModel.value.name) {
                store.commit("creative/modelEditor/setResetModel", Object.assign({}, currentResetModel.value, {
                    name: cat.name,
                    name_en: cat.name_en
                }));
            }
        };
        var rollback = function rollback(id) {
            var onlyChangeName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var cat = useIdToFindCategory({
                category: templateCategory.value,
                categoryId: id
            });
            // 获取当前动作库数据
            var targetModelAnimation = modelAnimationList.value.find(function(item) {
                return item.category_id === id;
            });
            if (targetModelAnimation.id) {
                var currentData = resetModel.value[JSON.stringify(targetModelAnimation.id)];
                if (currentData) {
                    if (typeof currentData.name !== "undefined" || typeof currentData.name_en !== "undefined") {
                        cat.name = currentData.name;
                        cat.name_en = currentData.name_en;
                    }
                    // 为什么需要这个传参，如果是取消弹框的话，不需要重置 speed 和 events，因为都不会入库
                    if (onlyChangeName) return;
                    if (typeof currentData.speed !== "undefined" || typeof currentData.events !== "undefined" || typeof currentData.rotate !== "undefined") {
                        var targetValue = {};
                        if (typeof currentData.speed !== "undefined") {
                            targetValue.speed = currentData.speed;
                        }
                        if (typeof currentData.rotate !== "undefined") {
                            targetValue.rotate = currentData.rotate;
                        }
                        if (typeof currentData.events !== "undefined") {
                            targetValue.events = currentData.events;
                        }
                        // 如果是当前编辑中的动画，直接重置 animationModel
                        if (targetModelAnimation.file_path === animationPath.value) {
                            store.commit("creative/modelEditor/setAnimationModel", Object.assign({}, animationModel.value, targetValue));
                        } else {
                            var targetIndex = modelAnimationList.value.findIndex(function(item) {
                                return item.category_id === id;
                            });
                            var oldAnimationModel = _.cloneDeep(animationModel.value);
                            store.commit("creative/modelEditor/setModelAnimationListByIndex", {
                                index: targetIndex,
                                data: Object.assign({}, {
                                    file_path: targetModelAnimation.file_path
                                }, targetValue)
                            });
                            // 不知道为啥重置上一个数据会影响到当前的 model ,所以需要重置 后面再优化 todo
                            setTimeout(function() {
                                if (!_.isEqual(oldAnimationModel !== animationModel.value)) {
                                    store.commit("creative/modelEditor/setAnimationModel", oldAnimationModel);
                                }
                            }, 0);
                        }
                    }
                }
            }
        };
        var rollbackAll = function rollbackAll() {
            var catIds = modelAnimationList.value.map(function(i) {
                return i.category_id;
            });
            catIds.forEach(function(id) {
                rollback(Number(id), true);
            });
        };
        var handleSubmit = function handleSubmit() {
            dialogValue.value.animation_ids.forEach(function(id) {
                setRollBackDataById(id);
                var animationCategory = useIdToFindCategory({
                    category: templateCategory.value,
                    categoryId: id
                });
                if (dialogValue.value.is_edit_model) {
                    animationCategory.name = dialogValue.value.name;
                    animationCategory.name_en = dialogValue.value.name_en;
                }
                var modelAnimation = getModelAnimationByAnimationCategory({
                    modelAnimationResource: cocosActionResourceList.value,
                    modelCategory: category1.value,
                    animationCategory: animationCategory
                });
                // 如果是新增的动作，需要增加数据
                if (modelAnimationList.value.findIndex(function(item) {
                    return item.file_path === modelAnimation.file_path;
                }) === -1) {
                    var temp = _.cloneDeep(modelAnimationList.value);
                    temp.push(modelAnimation);
                    store.commit("creative/modelEditor/setModelAnimationList", temp);
                }
            });
            dialogConfig.visible = false;
        };
        var handleDelete = function handleDelete() {
            if (dialogValue.value.is_default) {
                Message.error("\u5F53\u524D\u52A8\u4F5C\u662F\u901A\u8FC7\u547D\u540D\u7ED1\u5B9A\u5185\u7F6E\u7684\u52A8\u4F5C\uFF0C\u4E0D\u5141\u8BB8\u5220\u9664");
            } else {
                store.commit("creative/modelEditor/setModelAnimationList", _toConsumableArray(modelAnimationList.value.filter(function(item) {
                    return item.id !== dialogValue.value.id;
                })));
                store.commit("creative/modelEditor/deleteAnimationConfigById", dialogValue.value.id);
                store.commit("creative/modelEditor/setAnimationId", "");
                store.commit("creative/modelEditor/setAnimationPath", "");
                dialogConfig.visible = false;
            }
        };
        var editAnimation = function editAnimation(item) {
            dialogValue.value.id = item.id;
            var category = useIdToFindCategory({
                category: templateCategory.value,
                categoryId: item.category_id
            });
            dialogValue.value.is_default = item.is_default;
            dialogValue.value.animation_ids = [
                item.category_id
            ];
            dialogValue.value.name = category.name;
            dialogValue.value.name_en = category.name_en;
            dialogValue.value.is_edit_model = true;
            dialogConfig.visible = true;
        };
        var getActiveShowCategoryIDs = function getActiveShowCategoryIDs(ids) {
            var activeShowCategoryIDs = [];
            ids.forEach(function(id) {
                var category = useIdToFindCategory({
                    category: templateCategory.value,
                    categoryId: id
                });
                if (category && category.pid) {
                    var parentCategory = useIdToFindCategory({
                        category: templateCategory.value,
                        categoryId: category.pid
                    });
                    // 判断是否是预设选项下面的内容
                    if (isPresetOptionCategory(parentCategory) && _.get(store, "state.creative.template.templateConfig.json_config.presetConfig")) {
                        var presetConfig = _.get(store, "state.creative.template.templateConfig.json_config.presetConfig");
                        if (presetConfig[parentCategory.properties.preset].value !== parentCategory.prefix) {
                            console.log("\u5F53\u524D id \u7684\u5206\u7C7B\u88AB\u9690\u85CF\u4E86", id);
                            return;
                        }
                    }
                }
                activeShowCategoryIDs.push(id);
            });
            return activeShowCategoryIDs;
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var _$ref = useModelStore(store), modelAnimationList = _$ref.modelAnimationList, templateCategory = _$ref.templateCategory, cocosActionResourceList = _$ref.cocosActionResourceList, animationPath = _$ref.animationPath, category1 = _$ref.category, animationModel = _$ref.animationModel, resetModel = _$ref.resetModel, animationId = _$ref.animationId, replaceData = _$ref.replaceData, replaceMap = _$ref.replaceMap, resource = _$ref.resource;
        var currentResetModel = computed(function() {
            return resetModel.value[JSON.stringify(animationId.value)];
        });
        var currentResource = computed(function() {
            return useIdToFindResourceList({
                resource: resource.value,
                id: category1.value.id
            })[0];
        });
        var getTitleById = function(id) {
            var cat = useIdToFindCategory({
                category: templateCategory.value,
                categoryId: id
            });
            if (cat) {
                if (language.get() === "en") {
                    return cat.name_en;
                }
                return cat.name;
            }
            return id;
        };
        var activeNames = computed({
            get: function get() {
                return animationPath.value;
            },
            set: function set(value) {
                store.commit("creative/modelEditor/setAnimationPath", value);
            }
        });
        var handleReset = function(id) {
            var categoryAnimationList = _.cloneDeep(getAnimationList(category1.value));
            var curCat = useIdToFindCategory({
                category: templateCategory.value,
                categoryId: id
            });
            var isReplaceCat = replaceData.value && replaceData.value.length && replaceData.value.some(function(item) {
                return item.prefix === curCat.prefix;
            });
            // 如果当前重置的动画不在当前的动画列表中，重置即删除
            if (categoryAnimationList.findIndex(function(item) {
                return item.category_id === id;
            }) === -1 && !isReplaceCat) {
                root.$confirm("\u8BE5\u52A8\u753B\u4E3A\u65B0\u5173\u8054\u7684\u52A8\u4F5C\u8D44\u6E90\uFF0C\u91CD\u7F6E\u5373\u5220\u9664\uFF0C\u786E\u8BA4\u5417\uFF1F", "\u63D0\u793A", {
                    confirmButtonText: "\u786E\u5B9A",
                    cancelButtonText: "\u53D6\u6D88",
                    type: "warning"
                }).then(function() {
                    var targetModelAnimation = modelAnimationList.value.find(function(item) {
                        return item.category_id === id;
                    });
                    // 如果删除的是当前编辑的动画，需要重置
                    if (targetModelAnimation.file_path === animationPath.value) {
                        store.commit("creative/modelEditor/setAnimationId", "");
                        store.commit("creative/modelEditor/setAnimationPath", "");
                    }
                    var temp = _.cloneDeep(modelAnimationList.value).filter(function(item) {
                        return item.category_id !== id;
                    });
                    store.commit("creative/modelEditor/setModelAnimationList", temp);
                }).catch(function() {});
            } else {
                // 如果是替换的动画坑位
                if (isReplaceCat) {
                    store.commit("creative/modelEditor/setReplaceData", replaceData.value.filter(function(item) {
                        return item.prefix !== curCat.prefix;
                    }));
                    // 获取替换后的动画子数据
                    var modelAnimationItem = modelAnimationList.value.find(function(item) {
                        return item.category_id === id;
                    });
                    var targetIndex = modelAnimationList.value.findIndex(function(item) {
                        return item.category_id === id;
                    });
                    var originAnimationItem = categoryAnimationList.find(function(item) {
                        return item.file_path === modelAnimationItem.file_path;
                    });
                    if (modelAnimationItem && targetIndex !== -1 && originAnimationItem) {
                        var temp1 = _.cloneDeep(modelAnimationList.value);
                        temp1[targetIndex] = originAnimationItem;
                        store.commit("creative/modelEditor/setModelAnimationList", temp1);
                    }
                    if (replaceMap.value && replaceMap.value[id]) {
                        var replaceMapTemp = _.filter(replaceMap.value, function(item, key) {
                            return key !== id && item;
                        });
                        store.commit("creative/modelEditor/setReplaceMap", replaceMapTemp);
                    }
                }
                rollback(id, false);
            }
        };
        var dialogConfig = reactive({
            visible: false,
            loading: false,
            width: "500px",
            title: "\u5173\u8054\u52A8\u4F5C",
            labelPosition: "left",
            appendToBody: true,
            deleteLabel: "\u5220\u9664\u52A8\u4F5C"
        });
        var dialogValue = ref({
            is_default: false,
            id: "",
            animation_ids: [],
            name: "",
            name_en: "",
            is_edit_model: false
        });
        var resetDialogValue = function() {
            dialogValue.value.is_default = false;
            dialogValue.value.animation_ids = [];
            dialogValue.value.is_edit_model = false;
            dialogValue.value.id = "";
            dialogValue.value.name = "";
            dialogValue.value.name_en = "";
        };
        var createNewAnimation = function() {
            resetDialogValue();
            dialogConfig.visible = true;
        };
        var dialogFormConfig = reactive({
            labelPosition: "left",
            labelWidth: "150px",
            size: "mini"
        });
        var dialogItemList = computed(function() {
            return [
                {
                    visible: Boolean(dialogValue.value.is_edit_model),
                    label: "\u4E2D\u6587\u540D\u79F0",
                    type: "input",
                    prop: "name",
                    rules: [
                        {
                            required: true
                        }, 
                    ]
                },
                {
                    visible: Boolean(dialogValue.value.is_edit_model),
                    label: "\u82F1\u6587\u540D\u79F0",
                    type: "input",
                    prop: "name_en",
                    rules: [
                        {
                            required: true
                        }, 
                    ]
                },
                {
                    visible: !dialogValue.value.is_edit_model,
                    label: "\u9009\u62E9\u52A8\u4F5C",
                    type: "select",
                    prop: "animation_ids",
                    rules: [
                        {
                            required: true
                        }, 
                    ],
                    params: {
                        clearable: true,
                        filterable: true,
                        multiple: true,
                        options: cocosActionResourceList.value.filter(function(res) {
                            return !modelAnimationList.value.some(function(item) {
                                return res.category_id === item.category_id;
                            });
                        }).filter(function(res) {
                            if (currentResource.value.extra && currentResource.value.extra.skeleton_type && res.extra && res.extra.skeleton_type) {
                                return res.extra.skeleton_type === currentResource.value.extra.skeleton_type;
                            }
                            return false;
                        }).map(function(item) {
                            return {
                                label: item.file_name,
                                value: item.category_id
                            };
                        })
                    }
                }, 
            ];
        });
        var tipsContentById = function(id1) {
            var currentModelAnimation = modelAnimationList.value.find(function(item) {
                return item.category_id === id1;
            });
            var modelTitles = [];
            if (currentModelAnimation && currentModelAnimation.model_category_ids && currentModelAnimation.model_category_ids.length > 1 && getActiveShowCategoryIDs(currentModelAnimation.model_category_ids).length > 1) {
                getActiveShowCategoryIDs(currentModelAnimation.model_category_ids).forEach(function(id) {
                    var cat = useIdToFindCategory({
                        category: templateCategory.value,
                        categoryId: id
                    });
                    if (cat) {
                        if (language.get() === "en") {
                            modelTitles.push(cat.name_en || cat.name);
                        } else {
                            modelTitles.push(cat.name);
                        }
                    }
                });
            }
            return root.$t("playTurbo.custom.modelEdit.action.sharedActionTip") + modelTitles.join("\u3001");
        };
        return {
            modelAnimationList: modelAnimationList,
            getTitleById: getTitleById,
            handleReset: handleReset,
            isMaterialWarehouse: isMaterialWarehouse,
            dialogConfig: dialogConfig,
            dialogValue: dialogValue,
            dialogFormConfig: dialogFormConfig,
            handleSubmit: handleSubmit,
            handleDelete: handleDelete,
            dialogItemList: dialogItemList,
            editAnimation: editAnimation,
            activeNames: activeNames,
            tipsContentById: tipsContentById,
            rollbackAll: rollbackAll,
            PtButtonType: PtButtonType,
            PtButtonTheme: PtButtonTheme,
            PtButtonSize: PtButtonSize,
            createNewAnimation: createNewAnimation,
            getActiveShowCategoryIDs: getActiveShowCategoryIDs,
            currentResource: currentResource,
            cocosActionResourceList: cocosActionResourceList
        };
    }
});
